import React from "react";
import GoogleMapReact from 'google-map-react';
import debounce from "lodash/debounce"
declare var process: any
// @ts-ignore
const isEqualExtent = (a,b) => {
    return a.nw.lat === b.nw.lat && a.se.lat === b.se.lat
        && a.nw.lng === b.nw.lng && a.se.lng === b.se.lng;
}

export default class StandardMap extends React.Component<any, any> {
  mapChangeListener: any;
  // @ts-ignore
  constructor(props) {
    super(props);

    this.state = {
      map: null,
      maps: null,
      currentMapExtent: null,
      mapChangeListener: null,
    }
  }

  // @ts-ignore
  onGApiLoaded = (args) => {
    const {map, maps} = args;
    this.setState({map, maps}, this.bindGMapsListeners);
  }

  // @ts-ignore
  bindGMapsListeners = () => {
    console.log('bindGMapsListeners', this.mapChangeListener);
    const {map, maps} = this.state;
    if (!this.mapChangeListener && map && maps) {
      this.mapChangeListener = maps.event.addListener(map, 'bounds_changed', debounce(this.onMapBoundsChanged, 500));
    }
  }

  // @ts-ignore
  unbindGMapsListeners = () => {
    console.log('unbindGMapsListeners', this.mapChangeListener);
    const {maps} = this.state;
    if (this.mapChangeListener && maps) {
      maps.event.removeListener(this.mapChangeListener)
      this.mapChangeListener = null;
    }
  }

  // @ts-ignore
  onMapBoundsChanged = () => {
    const {onMapExtentChange} = this.props;
    const {map, currentMapExtent} = this.state;
    const newBounds = map.getBounds();
    const newZoom = map.getZoom();
    if (!currentMapExtent) {
      this.setState({
        currentMapExtent: true
      });
    } else {
      console.log('onMapExtentChange', {
        lat1: newBounds.getNorthEast().lat(),
        lat2: newBounds.getSouthWest().lat(),
        lng1: newBounds.getSouthWest().lng(),
        lng2: newBounds.getNorthEast().lng(),
        zoom: newZoom
      });
      onMapExtentChange({
        lat1: newBounds.getNorthEast().lat(),
        lat2: newBounds.getSouthWest().lat(),
        lng1: newBounds.getSouthWest().lng(),
        lng2: newBounds.getNorthEast().lng(),
        zoom: newZoom
      });
    }
  };

  // @ts-ignore
  getLocationsBounds = (map, maps) => {
    const {locations} = this.props;
    const bounds = new maps.LatLngBounds();

    // @ts-ignore
    locations.forEach((location) => {
      bounds.extend(
        new maps.LatLng(location.lat, location.lng),
      );
    });
    return bounds;
  };

  adjustMapToLocations = () => {
    const {map, maps} = this.state;
    const {locations, shouldAdjustMapExtentToLocations} = this.props;
    console.log('adjustMapToLocations', locations.length);
    if (!map) {
      return;
    }
    //the results list is controlling the map
    //The map is automatically centered on markers in this mode
    if (Array.isArray(locations) && locations.length === 1) {
      const currentZoom = map.getZoom();
      const currentCenter = map.getCenter();
      console.log({currentZoom, currentCenter});
      this.unbindGMapsListeners();
      map.setZoom(14);
      map.setCenter({lat : locations[0].lat, lng: locations[0].lng});
      setTimeout(this.bindGMapsListeners, 300);
    } else if (Array.isArray(locations) && locations.length > 1) {
      this.unbindGMapsListeners();
      const currentBounds = map.getBounds();
      const locationsBounds = this.getLocationsBounds(map, maps);
      if (!currentBounds.equals(locationsBounds)) {
        console.log('Bounds need updating to focus around locations of interests', {currentBounds, locationsBounds});
        map.fitBounds(locationsBounds);
        setTimeout(this.bindGMapsListeners, 300);
      }
    }
  }

  // @ts-ignore
  componentDidUpdate(prevProps: Readonly<IStandardMapProps>): void {
    //we only want to auto center around results
    //when the results control the map
    const {locations: oldLocations} = prevProps;
    const {locations: newLocations, shouldAdjustMapExtentToLocations} = this.props;

    // let locationsHaveUpdated = false;
    // if (oldLocations.length === newLocations.length) {
    //   for (let i=0; i<newLocations.length;i++) {
    //     if (newLocations[i].id !== oldLocations[i].id) {
    //       locationsHaveUpdated =  true;
    //       break;
    //     }
    //   }
    // } else {
    //   locationsHaveUpdated = true
    // }

    if (shouldAdjustMapExtentToLocations) {
      this.adjustMapToLocations();
    }
  }

  buildZoomControls(controlDiv: any, map: any, maps: any) : any {
    // Creating divs & styles for custom zoom control
    controlDiv.style.padding = '5px';

    // Set CSS for the control wrapper
    var controlWrapper = document.createElement('div');
    controlWrapper.style.backgroundColor = 'white';
    controlWrapper.style.borderStyle = 'solid';
    controlWrapper.style.borderColor = 'gray';
    controlWrapper.style.borderWidth = '1px';
    controlWrapper.style.cursor = 'pointer';
    controlWrapper.style.textAlign = 'center';
    controlWrapper.style.width = '32px';
    controlWrapper.style.height = '64px';
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    var zoomInButton = document.createElement('div');
    zoomInButton.style.width = '32px';
    zoomInButton.style.height = '32px';
    /* Change this to be the .png image you want to use */
    zoomInButton.style.backgroundImage = 'url("http://placehold.it/32/00ff00")';
    controlWrapper.appendChild(zoomInButton);

    // Set CSS for the zoomOut
    var zoomOutButton = document.createElement('div');
    zoomOutButton.style.width = '32px';
    zoomOutButton.style.height = '32px';
    /* Change this to be the .png image you want to use */
    zoomOutButton.style.backgroundImage = 'url("http://placehold.it/32/0000ff")';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    maps.event.addDomListener(zoomInButton, 'click', () => {
      // this.bindGMapsListeners();
      map.setZoom(map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    maps.event.addDomListener(zoomOutButton, 'click', () => {
      // this.bindGMapsListeners();
      map.setZoom(map.getZoom() - 1);
    });

  }

  render() {
    const props = this.props;
    return (
      <div style={{ height: props.height, width: props.width, position: 'sticky', top: 0 }}>
        <GoogleMapReact
            // @ts-ignore
          options={{
            streetViewControl: true,
            mapTypeControl: true,
            disableDefaultUI: false
          }}
          // onDrag={this.bindGMapsListeners}
          // onClick={this.bindGMapsListeners}
          onGoogleApiLoaded={this.onGApiLoaded}
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY : "" }}
          center={this.props.center}
          zoom={this.props.zoom}
          yesIWantToUseGoogleMapApiInternals={true}
        >
          {props.children}
        </GoogleMapReact>
      </div>
    );
  }
}

export interface IStandardPoint {
  latitude: number;
  longitude: number;
}

interface IStandardMapPoint {
  latitude: number;
  longitude: number;
}

export interface IStandardMapProps {
  center: IStandardMapPoint;
  locations: any[];
  showSatellite?: boolean;
  zoom?: number;
  showMapControl?: boolean;
  className?: string;
  mapIcons?: IStandardMapIcon[];
  shouldAdjustMapExtentToLocations?: any;
  onMapExtentChange: Function;
}

export interface IStandardScreenIcon extends IStandardMapIcon {
  postOnClick: any;
  screenPoint: any;
  selected: boolean;
}
//
export interface IStandardMapIcon {
  id: string;
  point: IStandardPoint;
  createIconComponent: Function;
  iconWidth: string;
  iconHeight: string;
}



// WEBPACK FOOTER //
// ./src/components/lib/StandardMap/StandardMap.tsx